import xhr from 'xhr';

export default async function getStudentHistory(data) {
  const res = await xhr(`/student-histories?filters[student][id][$eq]=${data.id}&sort[0]=id:desc&populate=*`);

  return res.data.data;
}
